const INSTALLATION_ID_KEY = 'ac_pwa_installation_id';
const INSTALLATION_TIME_KEY = 'ac_pwa_installation_time';

function generateUUID(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}-${Math.random().toString(36).slice(2, 11)}`;
}

/**
 * Retorna o ID de Instalação Único persistido no localStorage.
 * Se não existir, gera um novo e registra a data/hora da instalação.
 */
let inMemoryInstId: string | null = null;
let inMemoryInstTime: string | null = null;

export function getPwaInstallationId(): string {
  if (typeof window === 'undefined') return 'server';

  let installationId: string | null = null;
  try {
    installationId = localStorage.getItem(INSTALLATION_ID_KEY);
  } catch {
    installationId = inMemoryInstId;
  }

  if (!installationId) {
    installationId = generateUUID();
    try {
      localStorage.setItem(INSTALLATION_ID_KEY, installationId);
      localStorage.setItem(INSTALLATION_TIME_KEY, new Date().toISOString());
    } catch {
      inMemoryInstId = installationId;
      inMemoryInstTime = new Date().toISOString();
    }
  }

  return installationId;
}

/**
 * Retorna os metadados da instalação atual do PWA.
 */
export function getPwaDeviceMetadata() {
  if (typeof window === 'undefined') {
    return { isServer: true };
  }

  const ua = navigator.userAgent;
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua) || window.innerWidth < 768;
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches || (navigator as any).standalone === true;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown-timezone';

  return {
    installationId: getPwaInstallationId(),
    installationTime: (() => {
      try {
        return localStorage.getItem(INSTALLATION_TIME_KEY) || new Date().toISOString();
      } catch {
        return inMemoryInstTime || new Date().toISOString();
      }
    })(),
    isMobile,
    isStandalone,
    navegador: /Chrome/.test(ua) ? 'Chrome' : /Firefox/.test(ua) ? 'Firefox' : /Safari/.test(ua) ? 'Safari' : 'Outro',
    sistemaOp: /Windows/.test(ua) ? 'Windows' : /Mac/.test(ua) ? 'macOS' : /Linux/.test(ua) ? 'Linux' : 'Outro',
    userAgent: ua,
    language: navigator.language,
    resolution: `${screen.width}x${screen.height}`,
    timezone,
  };
}
